<template>
  <v-dialog 
    v-model="activeMode"  
    max-width="400"
    @click:outside="closeForm()"
    :fullscreen="$vuetify.breakpoint.smAndDown"
  >
    
    <template v-slot:activator="{ on }">
       <v-btn v-if="value" icon v-on="on">
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
      
      <v-btn v-else 
        fab 
        dark 
        small 
        color="primary"
        v-on="on"
      >
        <v-icon dark>mdi-plus</v-icon>
      </v-btn>
    </template>
    
    <v-card>
      <v-toolbar
        color="primary"
        dark
        flat
      >
        <v-toolbar-title>{{ title }}</v-toolbar-title>

        <v-spacer></v-spacer>

         <v-btn icon @click="closeForm()">
          <v-icon>mdi-close</v-icon>
        </v-btn>

      </v-toolbar>
      
      <v-card-text class="mt-7"><v-form ref="form" v-model="isValid">
        <v-alert 
          dense 
          outlined
          type="error" 
          :value="Boolean(error)"
          transition="scale-transition"
        >
          {{ error }}
        </v-alert>

        <v-autocomplete
          v-model="rentDeal.partner._id"
          label="Арендатор *"
          :items="partnerUsers"
          filled
          clearable
          item-value="_id"
          item-text="fullName"
          :rules="[v => !!v || 'Выберите арендатора сайта.']"
        ></v-autocomplete>

        <!--<v-menu
          ref="menu"
          v-model="datesMenu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              :value="rentDeal._dates[0] && rentDeal._dates[1] ? rentDeal._dates[0] + ' ~ ' + rentDeal._dates[1] : ''"
              label="Срок действия *"
              readonly
              filled
              v-bind="attrs"
              v-on="on"
              :rules="[v => !!v || 'Выберите срок аренды.']"
              @click="error = ''"
            ></v-text-field>
          </template>
          <v-date-picker v-model="rentDeal._dates" no-title scrollable range>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="rentDeal._dates = ['', '']; datesMenu = false;">Отмена</v-btn>
            <v-btn text color="primary" :disabled="!rentDeal._dates[1]" @click="datesMenu = false;">ОК</v-btn>
          </v-date-picker>
        </v-menu>-->

        <date-picker-new
          v-model="rentDeal.startedAt"
          name="Дата начала аренды"
          :start="true"
        ></date-picker-new>

        <date-picker-new
          v-model="rentDeal.finishedAt"
          name="Дата окончания аренды"
          :start="false"
        ></date-picker-new>

        <v-text-field
          v-model="rentDeal.costPerMonth"
          label="Ставка аренды *"
          append-icon="mdi-currency-rub"
          filled
          :rules="[v => String(Number(v)) == v || 'Ставка аренды должна быть числом.']"
        >
        </v-text-field>

        <v-text-field
          v-model="rentDeal.notifySms"
          label="SMS-оповещение"
          filled
          :prefix="phoneNumberPrefix"
          @focus="phoneNumberPrefix = '+7'"
          @blur="rentDeal.notifySms || (phoneNumberPrefix = '')"
          v-mask="'##########'"
          :rules="[v => !v || (v.length == 10) || 'Введите правильный номер.']"
        >
        </v-text-field>

        <v-text-field
          v-model="rentDeal.notifyEmail"
          label="Email-оповещение"
          filled
          :rules="[v => !v || isEmail(v) || 'Введите правильный email.']"
        >
        </v-text-field>

      </v-form></v-card-text>

       <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="blue darken-1" text @click="closeForm()">Закрыть</v-btn>

          <v-btn 
            color="blue darken-1" 
            text 
            @click="save"
          >Сохранить</v-btn>

       </v-card-actions>

    </v-card>
 </v-dialog>
</template>

<script>
import DateTimeLocal from '../../../models/datetime';
import { getTempId } from '../../../models/common';
import _ from 'lodash';
import { mapGetters, mapState } from 'vuex';
import DatePickerNew from '../../common/DatePickerNew.vue';

export default {
  components: { DatePickerNew },
  name: 'rent-deal',

  props: {
    value: Object,
    allDeals: Array
  },

  data() {
    return {
      activeMode: false,
      error: '',
      title: this.value ? 'Карточка договора' : 'Создание договора',
      datesMenu: false,
      isValid: false,
      phoneNumberPrefix: this.value && this.value.notifySms ? '+7' : '',

      rentDeal: this.value ? _.cloneDeep(this.value) : this.setDefaultObj()
    }
  },

  methods: {
    setDefaultObj() {
      return {
        _id: getTempId(),

        partner: {
          _id: null
        },
        costPerMonth: 0,
        cashFlow: [],

        startedAt: null,
        finishedAt: null,
        _dates: ['', '']
      };
    },

    save() {
      this.$refs.form.validate();
      if (this.isValid) {
        this.error = '';
        if (!this.rentDeal.startedAt || !this.rentDeal.finishedAt || 
            this.rentDeal.startedAt >= this.rentDeal.finishedAt
        ) {
          this.error = 'Выберите корректные даты аренды (с-по).';
          return;
        }
        //this.rentDeal.startedAt = DateTimeLocal.getStartDateFromISO(this.rentDeal._dates[0]);
        //this.rentDeal.finishedAt = DateTimeLocal.getFinishDateFromISO(this.rentDeal._dates[1]);
        this.rentDeal.partner = this.users.find(x => x._id == this.rentDeal.partner._id);

        for (let element of this.allDeals) {
          if (element == this.value) continue;
          //alert( JSON.stringify(element) );
          if (DateTimeLocal.haveCommonSegment(
              element.startedAt, element.finishedAt,
              this.rentDeal.startedAt, this.rentDeal.finishedAt
            )
          ) {
            this.error = 'Уже существует договор на указанные даты.';
            return;
          }
        }

        this.$emit('input', this.rentDeal);
        this.closeForm(true);
      }
    },

    closeForm(success = false) {
      this.error = '';
      this.rentDeal = this.value ? 
        (!success ? _.cloneDeep(this.value) : this.rentDeal) :
        this.setDefaultObj();
      this.$refs.form.resetValidation();
      this.activeMode = false;
    }
  },

  computed: {
    ...mapGetters('users', ['partnerUsers']),
    ...mapState('users', ['users'])
  }
}
</script>